<div class="chartView">
  <div class="chartViewRender">
    <div class="filters">
      <div class="switchView">
        <button
          class="p-menu-bar-button"
          icon="fas fa-chart-pie"
          pButton
          tooltipPosition="top"
          type="button"
          [hideDelay]="250"
          [life]="3000"
          pTooltip="{{ tooltipLabels.pieChart }}"
          (click)="switchToPieChart()"></button>
        <button
          class="p-menu-bar-button"
          icon="fas fa-dot-circle"
          pButton
          tooltipPosition="top"
          type="button"
          [hideDelay]="250"
          [life]="3000"
          pTooltip="{{ tooltipLabels.doughnutChart }}"
          (click)="switchToDoughnutChart()"></button>
        <button
          class="p-menu-bar-button"
          icon="fas fa-bullseye"
          pButton
          tooltipPosition="top"
          type="button"
          [hideDelay]="250"
          [life]="3000"
          pTooltip="{{ tooltipLabels.polarChart }}"
          (click)="switchToPolarChart()"></button>
        <button
          class="p-menu-bar-button"
          icon="fas fa-chart-line"
          pButton
          tooltipPosition="top"
          type="button"
          [hideDelay]="250"
          [life]="3000"
          pTooltip="{{ tooltipLabels.lineChart }}"
          (click)="switchToLineChart()"></button>
        <button
          class="p-menu-bar-button"
          icon="fas fa-chart-area"
          pButton
          tooltipPosition="top"
          type="button"
          [hideDelay]="250"
          [life]="3000"
          pTooltip="{{ tooltipLabels.areaChart }}"
          (click)="switchToAreaChart()"></button>
        <button
          class="p-menu-bar-button"
          icon="far fa-chart-bar fa-rotate-90"
          pButton
          tooltipPosition="top"
          type="button"
          [hideDelay]="250"
          [life]="3000"
          pTooltip="{{ tooltipLabels.barChart }}"
          (click)="switchToBarChart()"></button>
        <button
          class="p-menu-bar-button"
          icon="fas fa-chart-bar"
          pButton
          tooltipPosition="top"
          type="button"
          [hideDelay]="250"
          [life]="3000"
          pTooltip="{{ tooltipLabels.columnChart }}"
          (click)="switchToColumnChart()"></button>
        <button
          class="p-menu-bar-button"
          icon="far fa-snowflake"
          pButton
          tooltipPosition="top"
          type="button"
          [hideDelay]="250"
          [life]="3000"
          pTooltip="{{ tooltipLabels.radarChart }}"
          (click)="switchToRadarChart()"></button>
      </div>
      <div class="operation">
        <iu-autocomplete-ui
          #operationField
          [data]="{
            items: operations,
          }"
          [fieldValue]="operation"
          [isStandalone]="true"
          [label]="'chartview.aggregate' | translate"
          (fieldValueModified)="changeOperationToCompute($event)" />
      </div>
      <div class="column">
        <iu-autocomplete-ui
          [data]="{
            items: columns,
          }"
          [fieldValue]="defaultColumn"
          [isStandalone]="true"
          [label]="'chartview.dataAggregate' | translate"
          (fieldValueModified)="changeColumnToCompute($event)" />
      </div>
    </div>

    <p-chart #chart [data]="dataChart" [height]="'70vh'" [options]="options" [type]="cleanChartType" />
  </div>
</div>
